import { Navigate, Outlet } from "react-router-dom"
import React from "react"
import Sidebar from "../src/components/Sidebar"
import { isUserLoggedIn } from "./libs/utils"
import Pubnub from "./Pubnub"
import { STORAGE } from "./libs/storage"
import { useNotificationWebSocket } from "./libs/hooks/useNotificationWebSocket"
import { useRefetchOnResume } from "./libs/hooks/useRefetchOnResume"
import { useGetNotificationSummary } from "./services/queries"

export const NotificationSummaryContext = React.createContext(null)

const AuthenticatedRoute = () => {
  useRefetchOnResume()

  if (!isUserLoggedIn()) {
    return <Navigate to="/login" replace />
  }

  const uuid = STORAGE.getPubnubUUID();
  useNotificationWebSocket();
  const { data: notificationDetail } = useGetNotificationSummary({ exclude_category: "CANCEL_BY_DRIVER" })
  const notificationSummary = notificationDetail?.data?.data || {}

  return (
    <div>
      <NotificationSummaryContext.Provider value={notificationSummary}>
        <Pubnub uuid={uuid}>
          <Sidebar>
            <Outlet />
          </Sidebar>
        </Pubnub>
      </NotificationSummaryContext.Provider>
    </div>
  )
}

export default AuthenticatedRoute
